import React, { useEffect } from "react";
import { Crewmate } from "./Crewmate";

export const InviteCard: React.FC = () => {
  useEffect(() => {
    // Add confetti effect when component mounts
    const timer = setTimeout(() => {
      createConfetti();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleRSVPClick = () => {
    const rsvpButton = document.querySelector(".rsvp-button");
    if (rsvpButton) {
      rsvpButton.classList.add("clicked");

      // Create temporary "VOTED!" text
      const votedText = document.createElement("div");
      votedText.textContent = "VOTED!";
      votedText.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #11802D;
        font-size: 2rem;
        font-weight: bold;
        font-family: 'VT323', monospace;
        pointer-events: none;
        animation: voteConfirm 1s ease-out forwards;
      `;

      (rsvpButton as HTMLElement).style.position = "relative";
      rsvpButton.appendChild(votedText);

      // Remove animation class and text after animation
      setTimeout(() => {
        rsvpButton.classList.remove("clicked");
        if (votedText.parentNode) {
          votedText.remove();
        }
      }, 1000);

      // Scroll to RSVP section to show WhatsApp links
      setTimeout(() => {
        const rsvpSection = document.querySelector(".rsvp-section");
        if (rsvpSection) {
          rsvpSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 500);
    }
  };

  const createConfetti = () => {
    const colors = [
      "#C51111",
      "#132ED1",
      "#11802D",
      "#ED54BA",
      "#F07D0D",
      "#F3F318",
    ];
    const confettiCount = 50;

    for (let i = 0; i < confettiCount; i++) {
      const confetti = document.createElement("div");
      confetti.style.cssText = `
        position: fixed;
        width: 10px;
        height: 10px;
        background: ${colors[Math.floor(Math.random() * colors.length)]};
        left: ${Math.random() * 100}%;
        top: -10px;
        opacity: ${Math.random() * 0.8 + 0.2};
        transform: rotate(${Math.random() * 360}deg);
        animation: confettiFall ${Math.random() * 3 + 2}s linear forwards;
        z-index: 9999;
      `;
      document.body.appendChild(confetti);

      // Remove confetti after animation
      setTimeout(() => {
        confetti.remove();
      }, 5000);
    }
  };

  return (
    <main className="invite-container">
      <div className="emergency-header">
        <div className="emergency-lights">
          <div className="light left"></div>
          <div className="light right"></div>
        </div>
        <h1 className="emergency-text">EMERGENCY MEETING!</h1>
      </div>

      <div className="main-content">
        <div className="birthday-announcement">
          <div className="birthday-content">
            {/* Decorative crewmates using React component */}
            <Crewmate
              key="decorative-red"
              color="red"
              size="small"
              className="decorative-crewmate top-left"
              style={{ top: "0%", left: "0%" }}
            />
            <Crewmate
              key="decorative-cyan"
              color="cyan"
              size="small"
              className="decorative-crewmate top-right"
              style={{ top: "0%", right: "0%" }}
            />
            <Crewmate
              key="decorative-orange"
              color="orange"
              size="small"
              className="decorative-crewmate bottom-left"
              style={{ bottom: "-20%", left: "30%", opacity: 0.4 }}
            />

            <h2 className="crewmate-name">Crewmate Andrey</h2>
            <p className="turning-age">
              is turning <span className="age-number">6</span>!
            </p>
          </div>
        </div>

        <div className="party-details">
          <h3 className="section-title">Mission Details:</h3>
          <div className="detail-card">
            <div className="detail-item">
              <span className="label">📅 Date:</span>
              <span className="value">Thursday, August 21, 2025</span>
            </div>
            <div className="detail-item">
              <span className="label">⏰ Time:</span>
              <span className="value">16:30 - 19:30</span>
            </div>
            <div className="detail-item">
              <span className="label">📍 Location:</span>
              <span className="value">
                <a
                  href="https://jurmala.another-world.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="location-link"
                >
                  VR Jurmala Another World
                </a>
              </span>
            </div>
          </div>
        </div>

        <div className="tasks-section">
          <h3 className="section-title">Party Tasks:</h3>
          <ul className="task-list">
            <li className="task-item">
              <span className="task-icon">🎮</span>
              <span className="task-text">Play Among Us games</span>
            </li>
            <li className="task-item">
              <span className="task-icon">🎂</span>
              <span className="task-text">Eat birthday cake</span>
            </li>
            <li className="task-item">
              <span className="task-icon">🎁</span>
              <span className="task-text">Open presents</span>
            </li>
            <li className="task-item">
              <span className="task-icon">🕵️</span>
              <span className="task-text">Find the impostor!</span>
            </li>
          </ul>
        </div>

        <div className="rsvp-section">
          <p className="rsvp-text">Will you join the crew?</p>
          <button className="rsvp-button" onClick={handleRSVPClick}>
            <span className="button-text">VOTE TO ATTEND</span>
          </button>
          <p className="rsvp-info">
            RSVP to:
            <a
              href="https://wa.me/37129123858?text=Hi%20Deniss!%20We%20would%20love%20to%20attend%20Andrey's%206th%20birthday%20party%20on%20August%2021st%20at%20VR%20Jurmala%20Another%20World%20(16:30-19:30).%20Please%20count%20us%20in!%20%F0%9F%8E%89"
              target="_blank"
              className="whatsapp-link"
            >
              +371 29123858 (Deniss)
            </a>{" "}
            /
            <a
              href="https://wa.me/37126727644?text=Hi%20Alina!%20We%20would%20love%20to%20attend%20Andrey's%206th%20birthday%20party%20on%20August%2021st%20at%20VR%20Jurmala%20Another%20World%20(16:30-19:30).%20Please%20count%20us%20in!%20%F0%9F%8E%89"
              target="_blank"
              className="whatsapp-link"
            >
              +371 26727644 (Alina)
            </a>
          </p>
        </div>

        <div className="dress-code">
          <p className="dress-text">
            Dress Code: Come as your favorite crewmate color!
          </p>
        </div>
      </div>

      <div className="impostor-hint">
        <p>There might be an impostor at the party... 🤫</p>
      </div>
    </main>
  );
};
